"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _NestedNav = _interopRequireDefault(require("ecosystem-marketplace-core/components/nav/NestedNav"));

var Tier = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/Tier"));

var _i18n = require("ecosystem-marketplace-core/utils/i18n");

var _tiers = require("../../../../constants/tiers");

var _NestedNavCheckboxItem = _interopRequireDefault(require("../inputs/NestedNavCheckboxItem"));

var TierGroupCheckboxItem = function TierGroupCheckboxItem(_ref) {
  var disabled = _ref.disabled,
      groupKey = _ref.groupKey,
      groupTiers = _ref.groupTiers,
      _onChange = _ref.onChange,
      selectedTiers = _ref.selectedTiers,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["disabled", "groupKey", "groupTiers", "onChange", "selectedTiers"]);
  var allSelected = (0, _react.useMemo)(function () {
    return groupTiers.every(function (tier) {
      return selectedTiers.includes(tier);
    });
  }, [groupTiers, selectedTiers]);
  var someSelected = (0, _react.useMemo)(function () {
    return groupTiers.some(function (tier) {
      return selectedTiers.includes(tier);
    });
  }, [groupTiers, selectedTiers]);
  var renderedChildTiers = (0, _react.useMemo)(function () {
    return groupTiers.map(function (tier) {
      return _react.default.createElement(_NestedNavCheckboxItem.default, {
        key: tier,
        checkboxProps: {
          checked: selectedTiers.includes(tier),
          disabled: disabled,
          onChange: function onChange(_ref2) {
            var checked = _ref2.target.checked;

            _onChange(checked, [tier]);
          }
        },
        title: _react.default.createElement(_FormattedMessage.default, {
          message: (0, _i18n.getTierI18nKey)(tier)
        })
      });
    }).toArray();
  }, [disabled, groupTiers, _onChange, selectedTiers]);
  return _react.default.createElement(_NestedNavCheckboxItem.default, (0, _extends2.default)({}, rest, {
    checkboxProps: {
      checked: allSelected,
      disabled: disabled,
      indeterminate: someSelected,
      onChange: function onChange(_ref3) {
        var checked = _ref3.target.checked;

        _onChange(checked, groupTiers.toArray());
      },
      value: groupKey
    },
    defaultOpen: allSelected || someSelected,
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "appMarketplace.storefront.filters.compatibility.items." + groupKey
    })
  }), renderedChildTiers);
};

var CompatibilityToggleGroup = function CompatibilityToggleGroup(_ref4) {
  var compatible = _ref4.compatible,
      isCustomer = _ref4.isCustomer,
      onCompatibleChange = _ref4.onCompatibleChange,
      onTiersChange = _ref4.onTiersChange,
      selectedTiers = _ref4.selectedTiers;
  var handleTiersChange = (0, _react.useCallback)(function (checked, values) {
    onTiersChange(checked ? selectedTiers.union(values) : selectedTiers.subtract(values));
  }, [onTiersChange, selectedTiers]);
  var renderedTierItems = (0, _react.useMemo)(function () {
    return _tiers.ORDER.map(function (tierOrTierGroup) {
      var disabled = !!compatible;

      if (tierOrTierGroup instanceof _tiers.TierGroup) {
        var groupKey = tierOrTierGroup.key,
            groupTiers = tierOrTierGroup.tiers;
        return _react.default.createElement(TierGroupCheckboxItem, {
          key: groupKey,
          disabled: disabled,
          groupKey: groupKey,
          groupTiers: groupTiers,
          onChange: handleTiersChange,
          selectedTiers: selectedTiers
        });
      }

      return _react.default.createElement(_NestedNavCheckboxItem.default, {
        key: tierOrTierGroup,
        checkboxProps: {
          checked: selectedTiers.includes(tierOrTierGroup),
          disabled: disabled,
          onChange: function onChange(_ref5) {
            var checked = _ref5.target.checked;
            handleTiersChange(checked, [tierOrTierGroup]);
          }
        },
        title: _react.default.createElement(_FormattedMessage.default, {
          message: (0, _i18n.getTierI18nKey)(tierOrTierGroup)
        })
      });
    });
  }, [compatible, handleTiersChange, selectedTiers]);
  return _react.default.createElement(_NestedNav.default, {
    className: "m-bottom-0"
  }, isCustomer && _react.default.createElement(_NestedNavCheckboxItem.default, {
    checkboxProps: {
      checked: compatible,
      onChange: function onChange(_ref6) {
        var checked = _ref6.target.checked;
        onCompatibleChange(checked);
      }
    },
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "appMarketplace.storefront.filters.compatibility.items.compatible"
    })
  }), renderedTierItems);
};

CompatibilityToggleGroup.propTypes = {
  compatible: _propTypes.default.bool,
  isCustomer: _propTypes.default.bool.isRequired,
  onCompatibleChange: _propTypes.default.func.isRequired,
  onTiersChange: _propTypes.default.func.isRequired,
  selectedTiers: _reactImmutableProptypes.default.iterableOf(_propTypes.default.oneOf(Object.values(Tier))).isRequired
};
var _default = CompatibilityToggleGroup;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/filters/CompatibilityToggleGroup.js
// module id = 718
// module chunks = 209 210 211 212